// import React from "react";

// interface BrowserData {
//   name: string;
//   sessions: number;
//   icon: string;
// }

// const browsers: BrowserData[] = [
//   { name: "Chrome", sessions: 99, icon: "/charts/chrome.png" }, // Replace with actual Chrome emoji or icon
//   { name: "Safari", sessions: 65, icon: "/charts/safari.png" }, // Safari
//   { name: "Firefox", sessions: 3, icon: "/charts/firefox.png" }, // Firefox
//   { name: "Samsung", sessions: 3, icon: "/charts/samsung.png" }, // Samsung Browser
//   { name: "Edge", sessions: 2, icon: "/charts/edge.png" }, // Edge
// ];

// const maxSessions = Math.max(...browsers.map((b) => b.sessions));

// const TechnologyChart: React.FC = () => {
//   return (
//     <div className="w-full h-full bg-white p-4 rounded-lg relative border hover:outline hover:outline-2 hover:outline-[#3F81FE]">
//       <div className="flex justify-between items-start mb-4">
//         <h2 className="text-lg font-semibold text-[#323232]">Technology</h2>
//         <select className="border border-gray-300 text-[#323232] text-sm px-4 py-2 rounded-lg">
//           <option className="">Browsers</option>
//         </select>
//       </div>

//       {browsers.map((browser, index) => (
//         <div key={index} className="w-full flex flex-col items-center mb-3">
//           {/* Browser Icon & Name */}
//           <div className="w-full flex items-center gap-4">
//             <img src={browser.icon} alt="" className="w-4 h-4" />
//             <span className="text-[#323232]">{browser.name}</span>
//           </div>

//           <div className="w-full flex gap-2 items-center">
//             {/* Bar */}
//             <div className="w-full flex-1 h-2 bg-white rounded-full relative">
//               <div
//                 className="h-2 bg-[#3F81FE] rounded-full"
//                 style={{
//                   width: `${(browser.sessions / maxSessions) * 100}%`,
//                 }}
//               ></div>
//             </div>

//             {/* Sessions Count */}
//             <span className="ml-3 text-[#7e7e7e] text-sm">
//               {browser.sessions} Sessions
//             </span>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default TechnologyChart;

import React, { useState } from "react";
import { FaDesktop, FaMobileAlt, FaTabletAlt, FaGlobe } from "react-icons/fa";
import { SiFlutter } from "react-icons/si";

interface TechnologyChartProps {
  data: any;
}

// const deviceIcons: Record<string, JSX.Element> = {
//   Mobile: <FaMobileAlt className="text-blue-500" />,
//   Tablet: <FaTabletAlt className="text-green-500" />,
//   Desktop: <FaDesktop className="text-gray-500" />,
//   Flutter: <SiFlutter className="text-sky-400" />,
// };

const deviceIcons: Record<string, JSX.Element> = {
  Mobile: <FaMobileAlt className="text-blue-500" />,
  Tablet: <FaTabletAlt className="text-green-500" />,
  Desktop: <FaDesktop className="text-gray-500" />,
  Flutter: <SiFlutter className="text-sky-400" />,
  "Samsung Browser": <FaGlobe className="text-purple-400" />,
  "Dart Client": <SiFlutter className="text-sky-400" />,
  Chrome: <FaGlobe className="text-yellow-400" />,
  Safari: <FaGlobe className="text-green-400" />,
  Firefox: <FaGlobe className="text-orange-400" />,
  Edge: <FaGlobe className="text-blue-400" />,
  Unknown: <FaDesktop className="text-gray-400" />,
};

const TechnologyChart: React.FC<TechnologyChartProps> = ({ data }) => {
  // const { selectedValue } = useCommonStore();

  const [selectedCategory, setSelectedCategory] = useState("Browsers");

  // const { filteredData } = useMemo(
  //   () => filterDataByDate(data, selectedValue),
  //   [data, selectedValue]
  // );

  const getDeviceType = (userAgent: string): string => {
    if (/mobile|android|iphone|ipod/i.test(userAgent)) return "Mobile";
    if (/tablet|ipad/i.test(userAgent)) return "Tablet";
    return "Desktop";
  };

  const browserSessions: Record<string, { sessions: number; device: string }> =
    {};
  const deviceSessions: Record<string, number> = {
    Mobile: 0,
    Tablet: 0,
    Desktop: 0,
    Flutter: 0,
  };

  data?.Sessions?.forEach((item: any) => {
    const userAgent = item?.user_agent;
    const deviceType = getDeviceType(userAgent);

    deviceSessions[deviceType] += 1;

    let browserName = "Unknown";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      browserName = "Chrome";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      browserName = "Safari";
    } else if (userAgent.includes("Firefox")) {
      browserName = "Firefox";
    } else if (userAgent.includes("Edg")) {
      browserName = "Edge";
    } else if (userAgent.includes("Samsung")) {
      browserName = "Samsung Browser";
    } else if (userAgent.includes("Dart")) {
      browserName = "Dart Client";
    }

    if (!browserSessions[browserName]) {
      browserSessions[browserName] = { sessions: 0, device: deviceType };
    }
    browserSessions[browserName].sessions += 1;
  });

  const chartData =
    selectedCategory === "Browsers"
      ? Object.entries(browserSessions).map(([name, { sessions, device }]) => ({
          name,
          sessions,
          device,
          icon: `/charts/${name.toLowerCase().replace(" ", "-")}.png`,
        }))
      : Object.entries(deviceSessions).map(([device, sessions]) => ({
          name: device,
          sessions,
          icon: "",
        }));

  const fallbackIconNames = ["Dart Client", "Samsung Browser"];

  const maxSessions = Math.max(...chartData.map((b) => b.sessions), 1);
  return (
    <div className="w-full h-full bg-white p-4 rounded-lg relative border hover:outline hover:outline-2 hover:outline-[#3F81FE]">
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-lg font-semibold text-[#323232]">Technology</h2>
        <select
          className="border border-gray-300 text-[#323232] text-sm px-4 py-2 rounded-lg"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="Browsers">Browsers</option>
          <option value="Devices">Devices</option>
        </select>
      </div>

      {chartData?.map((item, index) => (
        <div key={index} className="w-full flex flex-col items-center mb-3">
          <div className="w-full flex items-center gap-4">
            {/* {selectedCategory === "Browsers" ? (
              <img src={item.icon} alt="" className="w-4 h-4" />
            ) : (
              deviceIcons[item.name]
            )}{" "}
            <span className="text-[#323232]">{item.name}</span> */}

            {selectedCategory === "Browsers" ? (
              item.icon && !fallbackIconNames.includes(item.name) ? (
                <img
                  src={item.icon}
                  alt={item.name}
                  className="w-4 h-4"
                  onError={(e) => (e.currentTarget.style.display = "none")}
                />
              ) : (
                deviceIcons[item.name] ?? <FaGlobe className="text-gray-400" />
              )
            ) : (
              deviceIcons[item.name] ?? <FaGlobe className="text-gray-400" />
            )}
          </div>

          <div className="w-full flex gap-2 items-center">
            <div className="w-full flex-1 h-2 bg-white rounded-full relative">
              <div
                className="h-2 bg-[#3F81FE] rounded-full"
                style={{
                  width: `${(item.sessions / maxSessions) * 100}%`,
                }}
              ></div>
            </div>

            <span className="ml-3 text-[#7e7e7e] text-sm">
              {item.sessions} Sessions
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TechnologyChart;
